import { profileLabels } from '../../../data/constants';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const MultiSelectChip = ({
  handleBlur = () => {},
  selectedValue = [],
  dropDownItems,
  handleChange,
  allowMulti = true,
  creatable = false,
}) => {
  const commonProps = {
    placeholder: profileLabels.selectOption,
    styles: {
      control: (baseStyles) => ({
        ...baseStyles,
        marginTop: '15px',
        minHeight: '40px',
      }),
    },
    isMulti: allowMulti,
    value: selectedValue,
    options: dropDownItems,
    onChange: handleChange,
    onBlur: handleBlur,
  };

  return creatable ? (
    <CreatableSelect
      {...commonProps}
      placeholder="Type and press Enter to add..."
      components={{ DropdownIndicator: null, IndicatorSeparator: null }}
      formatCreateLabel={(inputText) => `Add "${inputText}"`}
      noOptionsMessage={() => null}
    />
  ) : (
    <Select {...commonProps} />
  );
};

export default MultiSelectChip;
